module.exports = __webpack_public_path__ + "static/media/homepod_dark.f1c70e95.svg";